<template>
    <app-layout ref="lo" title="Dashboard">
        <template #header>
            <BreadCrumb :breadcrumb="$page.props.bc" />
        </template>

        <div class="py-4">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
                <div class="bg-white overflow-hidden shadow-xl sm:rounded-lg">
                    <section class="text-gray-600 body-font">
                        <div class="container px-5 py-12 mx-auto">
                            <div class="flex flex-wrap w-full mb-5 flex-col">
                                <Toolbar>
                                    <template #start>
                                        <ButtonEdit
                                            label="Edit"
                                            @click="openFormEdit($event)"
                                            class="mr-1"
                                            :disabled="
                                                selected_pegawai.length != 1
                                            "
                                        />
                                        <ButtonSync
                                            label="Sync"
                                            @click="sync($event)"
                                            class="mr-1"
                                        />
                                    </template>
                                    <template #end> </template>
                                </Toolbar>
                            </div>
                            <div
                                class="w-full mb-5"
                                v-if="$page.props.last_sync_at"
                            >
                                <Alert
                                    :msg="
                                        'Sync terakhir pada : ' +
                                        $page.props.last_sync_at +
                                        ', oleh : ' +
                                        $page.props.sync_by +
                                        ', Stts : ' +
                                        $page.props.sync_stts
                                    "
                                />
                            </div>
                            <div class="w-full mb-20">
                                <EzDataTable
                                    ref="ezdt"
                                    :config="ezdtConfig"
                                    @getSelectedData="getSelectedPegawai"
                                />
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </div>
        <Dialog
            header="Edit Pegawai"
            :visible="displayModal"
            :style="{ width: '50vw' }"
            :modal="true"
            @update:visible="hideHandler"
        >
            <div class="w-full mb-3">
                {{ selected_pegawai_nama_lengkap }}
            </div>
            <template #footer>
                <form @submit.prevent="edit">
                    <InertiaButtonSave
                        :class="{ 'opacity-25': form.processing }"
                        label="Simpan"
                    />
                </form>
            </template>
        </Dialog>
    </app-layout>
</template>

<script>
import { defineComponent } from "vue";
import AppLayout from "@/Layouts/AppLayout";
import BreadCrumb from "@/Components/BreadCrumb";
import { FilterMatchMode, FilterOperator } from "primevue/api";
import Toolbar from "primevue/toolbar";
import ButtonAdd from "@/Components/ButtonAdd";
import ButtonSync from "@/Components/ButtonSync";
import ButtonDelete from "@/Components/ButtonDelete";
import ButtonEdit from "@/Components/ButtonEdit";
import RekeningForm from "@/Pages/Setting/Partials/RekeningForm";
import Dialog from "primevue/dialog";
import InertiaButtonSave from "@/Components/InertiaButtonSave.vue";
import JetLabel from "@/Jetstream/Label";
import Checkbox from "primevue/checkbox";
import EzDataTable from "@/Components/EzDataTable";
import { Pesan } from "@/constants";
import Alert from "@/Components/Alert";

export default defineComponent({
    components: {
        Toolbar,
        AppLayout,
        BreadCrumb,
        ButtonAdd,
        ButtonSync,
        ButtonDelete,
        ButtonEdit,
        RekeningForm,
        Dialog,
        InertiaButtonSave,
        JetLabel,
        Checkbox,
        EzDataTable,
        Alert,
    },
    data() {
        return {
            displayModal: false,
            selected_pegawai_id: null,
            selected_pegawai_nama_lengkap: null,
            ezdtConfig: {
                dtHeader: "Master Pegawai",
                globalFilter: [
                    "nama_lengkap",
                    "nip",
                    "jenis_pegawai",
                    "kondisi_pegawai",
                    "stts_pegawai",
                    "gol",
                    "fakultas",
                    "departemen",
                    "prodi",
                ],
                defineCols: [
                    {
                        field: "nama_lengkap",
                        header: "Nama",
                        style: "min-width: 25rem",
                        isFrozen: true,
                        col_type: "text",
                    },
                    {
                        field: "nip",
                        header: "NIP",
                        style: "min-width: 15rem",
                        col_type: "text",
                    },
                    {
                        field: "jenis_pegawai",
                        header: "Jns Pegawai",
                        style: "min-width: 10rem",
                        col_type: "text",
                    },
                    {
                        field: "kondisi_pegawai",
                        header: "Kondisi Pegawai",
                        style: "min-width: 10rem",
                        col_type: "text",
                    },
                    {
                        field: "tmt_kondisi_pegawai",
                        header: "Tmt Kondisi Pegawai",
                        style: "min-width: 10rem",
                        col_type: "date",
                    },
                    {
                        field: "stts_pegawai",
                        header: "Status",
                        style: "min-width: 10rem",
                        col_type: "text",
                    },
                    {
                        field: "gol",
                        header: "Gol",
                        style: "min-width: 10rem",
                        col_type: "text",
                    },
                    {
                        field: "fakultas",
                        header: "Fakultas",
                        style: "min-width: 15rem",
                        col_type: "text",
                    },
                    {
                        field: "departemen",
                        header: "Departemen",
                        style: "min-width: 15rem",
                        col_type: "text",
                    },
                    {
                        field: "prodi",
                        header: "Prodi",
                        style: "min-width: 15rem",
                        col_type: "text",
                    },
                ],
                dtSourceApiRoute: {
                    list: "pegawai.all",
                    drop: null,
                },
            },
            selected_pegawai: [],
            form: this.$inertia.form({
                _method: "PUT",
                id: null,
            }),
        };
    },
    methods: {
        // changePegawaiList: function (data) {
        //     this.$refs.ezdt.changeDataSourceList(data);
        //     this.$refs.ezdt.loadData();
        // },
        loadEzData: function () {
            this.$refs.ezdt.loadData();
        },
        getSelectedPegawai: function (data) {
            this.selected_pegawai = data;
            this.selected_pegawai_id = 0;
            if (data.length == 1) {
                this.selected_pegawai_id = data[0]["id"];
                this.selected_pegawai_nama_lengkap = data[0]["nama_lengkap"];
            }
        },
        sync: function (event) {
            let self = this;
            self.$confirm.require({
                target: event.currentTarget,
                message: "Yakin akan melakukan sync ?",
                icon: "pi pi-info-circle",
                acceptClass: "p-button-danger",
                accept: () => {
                    axios
                        .get(route("pegawai.sync"))
                        .then((res) => {
                            if (res.data.stts == Pesan.OK.STTS) {
                                self.$refs.ezdt.resetSelection();
                                self.$refs.ezdt.loadData();
                                self.$refs.lo.showPesan(
                                    "Data berhasil di sync."
                                );
                                self.$page.props.sync_stts =
                                    res.data.data.sync_stts;
                                self.$page.props.sync_msg =
                                    res.data.data.sync_msg;
                                self.$page.props.sync_by =
                                    res.data.data.sync_by;
                                self.$page.props.last_sync_at =
                                    res.data.data.last_sync_at;
                            }
                        })
                        .catch(function (error) {
                            //
                        })
                        .then(function () {
                            //
                        });
                },
                reject: () => {
                    //callback to execute when user rejects the action
                },
            });
        },
        openFormEdit: function (event) {
            // this.$refs.rekeningForm.populateEdit(this.selected_pegawai[0]);
            this.form.reset();
            this.form.id = this.selected_pegawai_id;
            this.openModal();
        },
        edit: function (event) {
            this.form.post(route("pegawai.store"), {
                errorBag: "edit",
                preserveScroll: true,
                onSuccess: () => {
                    //
                },
                onFinish: () => {
                    //
                    this.displayModal = false;
                    this.$refs.ezdt.resetSelection();
                    this.$refs.ezdt.loadData();
                },
            });
        },
        openModal: function () {
            this.displayModal = true;
        },
        hideHandler: function (value) {
            if (!value) {
                this.displayModal = false;
            }
        },
    },
});
</script>
